import script from "./ReportIssueWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportIssueWidget.vue?vue&type=script&setup=true&lang=js"

import "./ReportIssueWidget.vue?vue&type=style&index=0&id=47e77b66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47e77b66"]])

export default __exports__